export default __webpack_public_path__ + "static/media/eyes.1cf3deb6.JPG";